/**
 * Non-authoritative navigation index (ADR-DEV-DDX-UI-001).
 * Business state always re-fetched via GET /project/{id}.
 */

const KEY = "ddx.knownProjectIds";

export function listKnownProjectIds(): string[] {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    return Array.isArray(parsed)
      ? parsed.filter((x): x is string => typeof x === "string")
      : [];
  } catch {
    return [];
  }
}

export function rememberProjectId(projectId: string): void {
  const ids = listKnownProjectIds();
  if (!ids.includes(projectId)) {
    ids.unshift(projectId);
    sessionStorage.setItem(KEY, JSON.stringify(ids.slice(0, 100)));
  }
}

export function forgetProjectId(projectId: string): void {
  const ids = listKnownProjectIds().filter((id) => id !== projectId);
  sessionStorage.setItem(KEY, JSON.stringify(ids));
}
